export function DividerLine() {
  return <div className={"h-px bg-slate-200 w-full my-7"} />;
}
